
import { cn } from "../lib/utils";
import React from "react";

interface ExperienceCardProps {
  imageSrc: string;
  imageAlt: string;
  imageHint: string; // 👈 properly typed as string
  isActive: boolean;
}

export function ExperienceCard({
  imageSrc,
  imageAlt,
  imageHint,
  isActive,
}: ExperienceCardProps): JSX.Element {
  return (
    <div
      className={cn(
        "relative aspect-[3/4] w-full overflow-hidden rounded-2xl group transition-all duration-500 ease-in-out",
        isActive ? "shadow-2xl" : "shadow-md"
      )}
    >
      <img
        src={imageSrc}
        alt={imageAlt}
        data-ai-hint={imageHint}
        className={cn(
          "object-cover w-full h-full transition-transform duration-500 ease-in-out",
          isActive ? "scale-105" : "scale-100 group-hover:scale-105"
        )}
      />
    </div>
  );
}
